import { ArrowRight, BookOpen } from 'lucide-react';
import { guideEntries } from '../data';

const stripIds = ['horse', 'ground-squirrel', 'grasshopper', 'swallow', 'waterbird', 'meander'];

export function FieldGuideStrip() {
  return (
    <section className="field-strip" aria-label="Field guide cards">
      <div className="panel-heading">
        <BookOpen aria-hidden="true" />
        <div>
          <h2>今天可能遇到的朋友</h2>
          <p>点左侧“草原图鉴”可以看完整版本。这里先记住几个线索。</p>
        </div>
      </div>
      <div className="field-card-row">
        {guideEntries
          .filter((entry) => stripIds.includes(entry.id))
          .map((entry) => {
            const Icon = entry.icon;
            return (
              <article className="field-card" key={entry.id}>
                {entry.image ? (
                  <img src={entry.image} alt={entry.imageAlt} />
                ) : (
                  <Icon aria-hidden="true" />
                )}
                <span>{entry.type}</span>
                <b>{entry.name}</b>
                <p>{entry.signal}</p>
                {entry.imageCredit && <small>{entry.imageCredit}</small>}
              </article>
            );
          })}
        <a className="field-more" href="#guide">
          完整图鉴
          <ArrowRight aria-hidden="true" />
        </a>
      </div>
    </section>
  );
}
